import { Link } from "react-router-dom";
import { allCategories, getCategoryCount } from "@/data/videos";

export default function CategorySidebar({ activeId }: { activeId: string }) {
  return (
    <aside className="lg:sticky lg:top-20">
      <div className="rounded-lg border border-background-200/70 bg-background-100 p-4">
        <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
          <i className="ri-list-check-2 text-primary-600"></i>
          全部分类
        </h2>
        <nav className="mt-3 flex flex-col gap-1">
          <Link
            to="/search"
            className="flex cursor-pointer items-center justify-between rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-50 hover:text-primary-600"
          >
            <span className="flex items-center gap-2">
              <i className="ri-apps-2-line"></i>
              全部视频
            </span>
          </Link>
          {allCategories.map((cat) => {
            const active = cat.id === activeId;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`flex cursor-pointer items-center justify-between rounded-md px-3 py-2 text-sm transition-colors ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-50 hover:text-primary-600"
                }`}
              >
                <span className="flex items-center gap-2">
                  <i className={cat.icon}></i>
                  {cat.name}
                </span>
                <span
                  className={`text-xs ${active ? "text-background-200" : "text-foreground-400"}`}
                >
                  {getCategoryCount(cat.id)}
                </span>
              </Link>
            );
          })}
        </nav>
      </div>
    </aside>
  );
}